(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[938],{

/***/ 48814:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "y": () => (/* binding */ cls$),
  "Z": () => (/* binding */ ComUI_modal)
});

// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(56369);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(38389);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@babel/runtime/helpers/esm/objectSpread2.js
var objectSpread2 = __webpack_require__(81549);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(73009);
// EXTERNAL MODULE: ./node_modules/body-scroll-lock/lib/bodyScrollLock.esm.js
var bodyScrollLock_esm = __webpack_require__(58509);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/rc-dialog/node_modules/@babel/runtime/helpers/esm/extends.js
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}

;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/rc-dialog/node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}

;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/rc-dialog/node_modules/@babel/runtime/helpers/esm/iterableToArrayLimit.js
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}

;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/rc-dialog/node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}

;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/rc-dialog/node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js

function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}

;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/rc-dialog/node_modules/@babel/runtime/helpers/esm/nonIterableRest.js
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/rc-dialog/node_modules/@babel/runtime/helpers/esm/slicedToArray.js




function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}

// EXTERNAL MODULE: ./node_modules/@rc-component/portal/es/index.js + 7 modules
var es = __webpack_require__(54535);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/rc-dialog/es/context.js

var RefContext = /*#__PURE__*/react.createContext({});
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/rc-dialog/node_modules/@babel/runtime/helpers/esm/typeof.js
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/rc-dialog/node_modules/@babel/runtime/helpers/esm/toPrimitive.js

function toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}

;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/rc-dialog/node_modules/@babel/runtime/helpers/esm/toPropertyKey.js


function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}

;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/rc-dialog/node_modules/@babel/runtime/helpers/esm/defineProperty.js

function _defineProperty(e, r, t) {
  return (r = toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}

;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/rc-dialog/node_modules/@babel/runtime/helpers/esm/objectSpread2.js

function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}

// EXTERNAL MODULE: ./node_modules/rc-util/es/Dom/contains.js
var contains = __webpack_require__(94999);
// EXTERNAL MODULE: ./node_modules/rc-util/es/hooks/useId.js
var useId = __webpack_require__(7028);
// EXTERNAL MODULE: ./node_modules/rc-util/es/KeyCode.js
var KeyCode = __webpack_require__(15105);
// EXTERNAL MODULE: ./node_modules/rc-util/es/pickAttrs.js
var pickAttrs = __webpack_require__(64217);
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/rc-dialog/es/util.js
// =============================== Motion ===============================
function getMotionName(prefixCls, transitionName, animationName) {
  var motionName = transitionName;
  if (!motionName && animationName) {
    motionName = "".concat(prefixCls, "-").concat(animationName);
  }
  return motionName;
}

// =============================== Offset ===============================
function getScroll(w, top) {
  var ret = w["page".concat(top ? 'Y' : 'X', "Offset")];
  var method = "scroll".concat(top ? 'Top' : 'Left');
  if (typeof ret !== 'number') {
    var d = w.document;
    ret = d.documentElement[method];
    if (typeof ret !== 'number') {
      ret = d.body[method];
    }
  }
  return ret;
}
function offset(el) {
  var rect = el.getBoundingClientRect();
  var pos = {
    left: rect.left,
    top: rect.top
  };
  var doc = el.ownerDocument;
  var w = doc.defaultView || doc.parentWindow;
  pos.left += getScroll(w);
  pos.top += getScroll(w, true);
  return pos;
}
// EXTERNAL MODULE: ./node_modules/rc-motion/es/index.js + 13 modules
var rc_motion_es = __webpack_require__(29372);
// EXTERNAL MODULE: ./node_modules/rc-util/es/ref.js
var es_ref = __webpack_require__(42550);
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/rc-dialog/es/Dialog/Content/MemoChildren.js

/* harmony default export */ const MemoChildren = (/*#__PURE__*/react.memo(function (_ref) {
  var children = _ref.children;
  return children;
}, function (_, _ref2) {
  var shouldUpdate = _ref2.shouldUpdate;
  return !shouldUpdate;
}));
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/rc-dialog/es/Dialog/Content/Panel.js









var sentinelStyle = {
  width: 0,
  height: 0,
  overflow: 'hidden',
  outline: 'none'
};
var entityStyle = {
  outline: 'none'
};
var Panel = /*#__PURE__*/react.forwardRef(function (props, ref) {
  var prefixCls = props.prefixCls,
    className = props.className,
    style = props.style,
    title = props.title,
    ariaId = props.ariaId,
    footer = props.footer,
    closable = props.closable,
    closeIcon = props.closeIcon,
    onClose = props.onClose,
    children = props.children,
    bodyStyle = props.bodyStyle,
    bodyProps = props.bodyProps,
    modalRender = props.modalRender,
    onMouseDown = props.onMouseDown,
    onMouseUp = props.onMouseUp,
    holderRef = props.holderRef,
    visible = props.visible,
    forceRender = props.forceRender,
    width = props.width,
    height = props.height,
    modalClassNames = props.classNames,
    modalStyles = props.styles;

  // ================================= Refs =================================
  var _React$useContext = react.useContext(RefContext),
    panelRef = _React$useContext.panel;
  var mergedRef = (0,es_ref/* useComposeRef */.x1)(holderRef, panelRef);
  var sentinelStartRef = (0,react.useRef)();
  var sentinelEndRef = (0,react.useRef)();
  react.useImperativeHandle(ref, function () {
    return {
      focus: function focus() {
        var _sentinelStartRef$cur;
        (_sentinelStartRef$cur = sentinelStartRef.current) === null || _sentinelStartRef$cur === void 0 || _sentinelStartRef$cur.focus({
          preventScroll: true
        });
      },
      changeActive: function changeActive(next) {
        var _document = document,
          activeElement = _document.activeElement;
        if (next && activeElement === sentinelEndRef.current) {
          sentinelStartRef.current.focus({
            preventScroll: true
          });
        } else if (!next && activeElement === sentinelStartRef.current) {
          sentinelEndRef.current.focus({
            preventScroll: true
          });
        }
      }
    };
  });

  // ================================ Style =================================
  var contentStyle = {};
  if (width !== undefined) {
    contentStyle.width = width;
  }
  if (height !== undefined) {
    contentStyle.height = height;
  }
  // ================================ Render ================================
  var footerNode = footer ? /*#__PURE__*/react.createElement("div", {
    className: classnames_default()("".concat(prefixCls, "-footer"), modalClassNames === null || modalClassNames === void 0 ? void 0 : modalClassNames.footer),
    style: _objectSpread2({}, modalStyles === null || modalStyles === void 0 ? void 0 : modalStyles.footer)
  }, footer) : null;
  var headerNode = title ? /*#__PURE__*/react.createElement("div", {
    className: classnames_default()("".concat(prefixCls, "-header"), modalClassNames === null || modalClassNames === void 0 ? void 0 : modalClassNames.header),
    style: _objectSpread2({}, modalStyles === null || modalStyles === void 0 ? void 0 : modalStyles.header)
  }, /*#__PURE__*/react.createElement("div", {
    className: "".concat(prefixCls, "-title"),
    id: ariaId
  }, title)) : null;
  var closableObj = (0,react.useMemo)(function () {
    if (_typeof(closable) === 'object' && closable !== null) {
      return closable;
    }
    if (closable) {
      return {
        closeIcon: closeIcon !== null && closeIcon !== void 0 ? closeIcon : /*#__PURE__*/react.createElement("span", {
          className: "".concat(prefixCls, "-close-x")
        })
      };
    }
    return {};
  }, [closable, closeIcon, prefixCls]);
  var ariaProps = (0,pickAttrs/* default */.Z)(closableObj, true);
  var closeBtnIsDisabled = _typeof(closable) === 'object' && closable.disabled;
  var closerNode = closable ? /*#__PURE__*/react.createElement("button", _extends({
    type: "button",
    onClick: onClose,
    "aria-label": "Close"
  }, ariaProps, {
    className: "".concat(prefixCls, "-close"),
    disabled: closeBtnIsDisabled
  }), closableObj.closeIcon) : null;
  var content = /*#__PURE__*/react.createElement("div", {
    className: classnames_default()("".concat(prefixCls, "-content"), modalClassNames === null || modalClassNames === void 0 ? void 0 : modalClassNames.content),
    style: modalStyles === null || modalStyles === void 0 ? void 0 : modalStyles.content
  }, closerNode, headerNode, /*#__PURE__*/react.createElement("div", _extends({
    className: classnames_default()("".concat(prefixCls, "-body"), modalClassNames === null || modalClassNames === void 0 ? void 0 : modalClassNames.body),
    style: _objectSpread2(_objectSpread2({}, bodyStyle), modalStyles === null || modalStyles === void 0 ? void 0 : modalStyles.body)
  }, bodyProps), children), footerNode);
  return /*#__PURE__*/react.createElement("div", {
    key: "dialog-element",
    role: "dialog",
    "aria-labelledby": title ? ariaId : null,
    "aria-modal": "true",
    ref: mergedRef,
    style: _objectSpread2(_objectSpread2({}, style), contentStyle),
    className: classnames_default()(prefixCls, className),
    onMouseDown: onMouseDown,
    onMouseUp: onMouseUp
  }, /*#__PURE__*/react.createElement("div", {
    ref: sentinelStartRef,
    tabIndex: 0,
    style: entityStyle
  }, /*#__PURE__*/react.createElement(MemoChildren, {
    shouldUpdate: visible || forceRender
  }, modalRender ? modalRender(content) : content)), /*#__PURE__*/react.createElement("div", {
    tabIndex: 0,
    ref: sentinelEndRef,
    style: sentinelStyle
  }));
});
if (false) {}
/* harmony default export */ const Content_Panel = (Panel);
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/rc-dialog/es/Dialog/Content/index.js









var Content = /*#__PURE__*/react.forwardRef(function (props, ref) {
  var prefixCls = props.prefixCls,
    title = props.title,
    style = props.style,
    className = props.className,
    visible = props.visible,
    forceRender = props.forceRender,
    destroyOnClose = props.destroyOnClose,
    motionName = props.motionName,
    ariaId = props.ariaId,
    onVisibleChanged = props.onVisibleChanged,
    mousePosition = props.mousePosition;
  var dialogRef = (0,react.useRef)();

  // ============================= Style ==============================
  var _React$useState = react.useState(),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    transformOrigin = _React$useState2[0],
    setTransformOrigin = _React$useState2[1];
  var contentStyle = {};
  if (transformOrigin) {
    contentStyle.transformOrigin = transformOrigin;
  }
  function onPrepare() {
    var elementOffset = offset(dialogRef.current);
    setTransformOrigin(mousePosition && (mousePosition.x || mousePosition.y) ? "".concat(mousePosition.x - elementOffset.left, "px ").concat(mousePosition.y - elementOffset.top, "px") : '');
  }

  // ============================= Render =============================
  return /*#__PURE__*/react.createElement(rc_motion_es/* default */.ZP, {
    visible: visible,
    onVisibleChanged: onVisibleChanged,
    onAppearPrepare: onPrepare,
    onEnterPrepare: onPrepare,
    forceRender: forceRender,
    motionName: motionName,
    removeOnLeave: destroyOnClose,
    ref: dialogRef
  }, function (_ref, motionRef) {
    var motionClassName = _ref.className,
      motionStyle = _ref.style;
    return /*#__PURE__*/react.createElement(Content_Panel, _extends({}, props, {
      ref: ref,
      title: title,
      ariaId: ariaId,
      prefixCls: prefixCls,
      holderRef: motionRef,
      style: _objectSpread2(_objectSpread2(_objectSpread2({}, motionStyle), style), contentStyle),
      className: classnames_default()(className, motionClassName)
    }));
  });
});
Content.displayName = 'Content';
/* harmony default export */ const Dialog_Content = (Content);
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/rc-dialog/es/Dialog/Mask.js





var Mask = function Mask(props) {
  var prefixCls = props.prefixCls,
    style = props.style,
    visible = props.visible,
    maskProps = props.maskProps,
    motionName = props.motionName,
    className = props.className;
  return /*#__PURE__*/react.createElement(rc_motion_es/* default */.ZP, {
    key: "mask",
    visible: visible,
    motionName: motionName,
    leavedClassName: "".concat(prefixCls, "-mask-hidden")
  }, function (_ref, ref) {
    var motionClassName = _ref.className,
      motionStyle = _ref.style;
    return /*#__PURE__*/react.createElement("div", _extends({
      ref: ref,
      style: _objectSpread2(_objectSpread2({}, motionStyle), style),
      className: classnames_default()("".concat(prefixCls, "-mask"), motionClassName, className)
    }, maskProps));
  });
};
/* harmony default export */ const Dialog_Mask = (Mask);
// EXTERNAL MODULE: ./node_modules/rc-util/es/warning.js
var warning = __webpack_require__(80334);
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/rc-dialog/es/Dialog/index.js














var Dialog = function Dialog(props) {
  var _props$prefixCls = props.prefixCls,
    prefixCls = _props$prefixCls === void 0 ? 'rc-dialog' : _props$prefixCls,
    zIndex = props.zIndex,
    _props$visible = props.visible,
    visible = _props$visible === void 0 ? false : _props$visible,
    _props$keyboard = props.keyboard,
    keyboard = _props$keyboard === void 0 ? true : _props$keyboard,
    _props$focusTriggerAf = props.focusTriggerAfterClose,
    focusTriggerAfterClose = _props$focusTriggerAf === void 0 ? true : _props$focusTriggerAf,
    wrapStyle = props.wrapStyle,
    wrapClassName = props.wrapClassName,
    wrapProps = props.wrapProps,
    onClose = props.onClose,
    afterOpenChange = props.afterOpenChange,
    afterClose = props.afterClose,
    transitionName = props.transitionName,
    animation = props.animation,
    _props$closable = props.closable,
    closable = _props$closable === void 0 ? true : _props$closable,
    _props$mask = props.mask,
    mask = _props$mask === void 0 ? true : _props$mask,
    maskTransitionName = props.maskTransitionName,
    maskAnimation = props.maskAnimation,
    _props$maskClosable = props.maskClosable,
    maskClosable = _props$maskClosable === void 0 ? true : _props$maskClosable,
    maskStyle = props.maskStyle,
    maskProps = props.maskProps,
    rootClassName = props.rootClassName,
    modalClassNames = props.classNames,
    modalStyles = props.styles;
  if (false) {}
  var lastOutSideActiveElementRef = (0,react.useRef)();
  var wrapperRef = (0,react.useRef)();
  var contentRef = (0,react.useRef)();
  var _React$useState = react.useState(visible),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    animatedVisible = _React$useState2[0],
    setAnimatedVisible = _React$useState2[1];

  // ========================== Init ==========================
  var ariaId = (0,useId/* default */.Z)();
  function saveLastOutSideActiveElementRef() {
    if (!(0,contains/* default */.Z)(wrapperRef.current, document.activeElement)) {
      lastOutSideActiveElementRef.current = document.activeElement;
    }
  }
  function focusDialogContent() {
    if (!(0,contains/* default */.Z)(wrapperRef.current, document.activeElement)) {
      var _contentRef$current;
      (_contentRef$current = contentRef.current) === null || _contentRef$current === void 0 || _contentRef$current.focus();
    }
  }

  // ========================= Events =========================
  function onDialogVisibleChanged(newVisible) {
    // Try to focus
    if (newVisible) {
      focusDialogContent();
    } else {
      // Clean up scroll bar & focus back
      setAnimatedVisible(false);
      if (mask && lastOutSideActiveElementRef.current && focusTriggerAfterClose) {
        try {
          lastOutSideActiveElementRef.current.focus({
            preventScroll: true
          });
        } catch (e) {
          // Do nothing
        }
        lastOutSideActiveElementRef.current = null;
      }

      // Trigger afterClose only when change visible from true to false
      if (animatedVisible) {
        afterClose === null || afterClose === void 0 || afterClose();
      }
    }
    afterOpenChange === null || afterOpenChange === void 0 || afterOpenChange(newVisible);
  }
  function onInternalClose(e) {
    onClose === null || onClose === void 0 || onClose(e);
  }

  // >>> Content
  var contentClickRef = (0,react.useRef)(false);
  var contentTimeoutRef = (0,react.useRef)();

  // We need record content click incase content popup out of dialog
  var onContentMouseDown = function onContentMouseDown() {
    clearTimeout(contentTimeoutRef.current);
    contentClickRef.current = true;
  };
  var onContentMouseUp = function onContentMouseUp() {
    contentTimeoutRef.current = setTimeout(function () {
      contentClickRef.current = false;
    });
  };

  // >>> Wrapper
  // Close only when element not on dialog
  var onWrapperClick = null;
  if (maskClosable) {
    onWrapperClick = function onWrapperClick(e) {
      if (contentClickRef.current) {
        contentClickRef.current = false;
      } else if (wrapperRef.current === e.target) {
        onInternalClose(e);
      }
    };
  }
  function onWrapperKeyDown(e) {
    if (keyboard && e.keyCode === KeyCode/* default.ESC */.Z.ESC) {
      e.stopPropagation();
      onInternalClose(e);
      return;
    }

    // keep focus inside dialog
    if (visible && e.keyCode === KeyCode/* default.TAB */.Z.TAB) {
      contentRef.current.changeActive(!e.shiftKey);
    }
  }

  // ========================= Effect =========================
  (0,react.useEffect)(function () {
    if (visible) {
      setAnimatedVisible(true);
      saveLastOutSideActiveElementRef();
    }
  }, [visible]);

  // Remove direct should also check the scroll bar update
  (0,react.useEffect)(function () {
    return function () {
      clearTimeout(contentTimeoutRef.current);
    };
  }, []);
  var mergedStyle = _objectSpread2(_objectSpread2(_objectSpread2({
    zIndex: zIndex
  }, wrapStyle), modalStyles === null || modalStyles === void 0 ? void 0 : modalStyles.wrapper), {}, {
    display: !animatedVisible ? 'none' : null
  });

  // ========================= Render =========================
  return /*#__PURE__*/react.createElement("div", _extends({
    className: classnames_default()("".concat(prefixCls, "-root"), rootClassName)
  }, (0,pickAttrs/* default */.Z)(props, {
    data: true
  })), /*#__PURE__*/react.createElement(Dialog_Mask, {
    prefixCls: prefixCls,
    visible: mask && visible,
    motionName: getMotionName(prefixCls, maskTransitionName, maskAnimation),
    style: _objectSpread2(_objectSpread2({
      zIndex: zIndex
    }, maskStyle), modalStyles === null || modalStyles === void 0 ? void 0 : modalStyles.mask),
    maskProps: maskProps,
    className: modalClassNames === null || modalClassNames === void 0 ? void 0 : modalClassNames.mask
  }), /*#__PURE__*/react.createElement("div", _extends({
    tabIndex: -1,
    onKeyDown: onWrapperKeyDown,
    className: classnames_default()("".concat(prefixCls, "-wrap"), wrapClassName, modalClassNames === null || modalClassNames === void 0 ? void 0 : modalClassNames.wrapper),
    ref: wrapperRef,
    onClick: onWrapperClick,
    style: mergedStyle
  }, wrapProps), /*#__PURE__*/react.createElement(Dialog_Content, _extends({}, props, {
    onMouseDown: onContentMouseDown,
    onMouseUp: onContentMouseUp,
    ref: contentRef,
    closable: closable,
    ariaId: ariaId,
    prefixCls: prefixCls,
    visible: visible && animatedVisible,
    onClose: onInternalClose,
    onVisibleChanged: onDialogVisibleChanged,
    motionName: getMotionName(prefixCls, transitionName, animation)
  }))));
};
/* harmony default export */ const es_Dialog = (Dialog);
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/rc-dialog/es/DialogWrap.js






// fix issue #10656
/*
 * getContainer remarks
 * Custom container should not be return, because in the Portal component, it will remove the
 * return container element here, if the custom container is the only child of it's component,
 * like issue #10656, It will has a conflict with removeChild method in react-dom.
 * So here should add a child (div element) to custom container.
 * */

var DialogWrap = function DialogWrap(props) {
  var visible = props.visible,
    getContainer = props.getContainer,
    forceRender = props.forceRender,
    _props$destroyOnClose = props.destroyOnClose,
    destroyOnClose = _props$destroyOnClose === void 0 ? false : _props$destroyOnClose,
    _afterClose = props.afterClose,
    panelRef = props.panelRef;
  var _React$useState = react.useState(visible),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    animatedVisible = _React$useState2[0],
    setAnimatedVisible = _React$useState2[1];
  var refContext = react.useMemo(function () {
    return {
      panel: panelRef
    };
  }, [panelRef]);
  react.useEffect(function () {
    if (visible) {
      setAnimatedVisible(true);
    }
  }, [visible]);

  // Destroy on close will remove wrapped div
  if (!forceRender && destroyOnClose && !animatedVisible) {
    return null;
  }
  return /*#__PURE__*/react.createElement(RefContext.Provider, {
    value: refContext
  }, /*#__PURE__*/react.createElement(es/* default */.Z, {
    open: visible || forceRender || animatedVisible,
    autoDestroy: false,
    getContainer: getContainer,
    autoLock: visible || animatedVisible
  }, /*#__PURE__*/react.createElement(es_Dialog, _extends({}, props, {
    destroyOnClose: destroyOnClose,
    afterClose: function afterClose() {
      _afterClose === null || _afterClose === void 0 || _afterClose();
      setAnimatedVisible(false);
    }
  }))));
};
DialogWrap.displayName = 'Dialog';
/* harmony default export */ const es_DialogWrap = (DialogWrap);
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/rc-dialog/es/index.js



/* harmony default export */ const rc_dialog_es = (es_DialogWrap);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@meitu/xdesign-icon-font/dist/IconFont.js + 2 modules
var IconFont = __webpack_require__(74107);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/ComUI/cls.js
var cls = __webpack_require__(51811);
// EXTERNAL MODULE: ./node_modules/rc-util/lib/React/render.js
var render = __webpack_require__(24996);
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/dist/ComUI/modal/alert.js


/* eslint-disable @typescript-eslint/no-empty-function */ 



var closest = function closest(el, selector) {
    var matchesSelector = el.matches || el.webkitMatchesSelector || el.mozMatchesSelector || el.msMatchesSelector;
    var p = el;
    while(p){
        if (matchesSelector.call(p, selector)) {
            return p;
        }
        p = p.parentElement;
    }
    return null;
};
var alert_alert = function alert(_ref) {
    var _actionProps$actions;
    var title = _ref.title, message = _ref.message, _ref$actionProps = _ref.actionProps, actionProps = _ref$actionProps === void 0 ? {
        actions: [
            {
                text: "确定"
            }
        ],
        direction: "row"
    } : _ref$actionProps, _ref$className = _ref.className, className = _ref$className === void 0 ? "" : _ref$className, style = _ref.style, _ref$zIndex = _ref.zIndex, zIndex = _ref$zIndex === void 0 ? 999 : _ref$zIndex, closable = _ref.closable, closeIcon = _ref.closeIcon, footer = _ref.footer, iconFontProps = _ref.iconFontProps, _onClose = _ref.onClose;
    // ssr
    if (false) {}
    var closed = false;
    if (!title && !message) {
        throw new Error("Must specify either an alert title, or message, or both");
    // return { close: () => {} };
    }
    var div = document.createElement("div");
    document.body.appendChild(div);
    var close = function close() {
        (0,render/* unmount */.vE)(div);
        if (div && div.parentNode) {
            div.parentNode.removeChild(div);
        }
    };
    var actions = actionProps === null || actionProps === void 0 || (_actionProps$actions = actionProps.actions) === null || _actionProps$actions === void 0 ? void 0 : _actionProps$actions.map(function(button) {
        var orginPress = button.onPress || function() {};
        var canDoPromise = true;
        button.onPress = function() {
            if (closed) {
                return;
            }
            if (!canDoPromise) return;
            var res = orginPress();
            if (res !== null && res !== void 0 && res.then) {
                canDoPromise = false;
                res.then(function() {
                    closed = true;
                    close();
                }).catch(function() {}).finally(function() {
                    return canDoPromise = true;
                });
            } else {
                closed = true;
                close();
            }
        };
        button.closeModal = function() {
            closed = true;
            close();
        };
        return button;
    });
    var onWrapTouchStart = function onWrapTouchStart(e) {
        if (!/iPhone|iPod|iPad/i.test(navigator.userAgent)) {
            return;
        }
        var pNode = closest(e.target, ".".concat(cls$("footer")));
        if (!pNode) {
            e.preventDefault();
        }
    };
    // 兼容react18的waring
    (0,render/* render */.sY)(/*#__PURE__*/ react.createElement(ComUI_modal, {
        className: classnames_default()((0,defineProperty/* default */.Z)({}, cls$("only-title"), !message), className),
        visible: true,
        onClose: function onClose() {
            _onClose === null || _onClose === void 0 || _onClose();
            close();
        },
        transparent: true,
        title: title,
        transitionName: "am-zoom",
        closable: closable,
        closeIcon: closeIcon,
        maskClosable: false,
        actionProps: (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, actionProps), {}, {
            actions: actions
        }),
        maskTransitionName: "am-fade",
        wrapProps: {
            onTouchStart: onWrapTouchStart
        },
        style: style,
        zIndex: zIndex,
        footer: footer,
        iconFontProps: iconFontProps
    }, /*#__PURE__*/ react.createElement("div", {
        className: cls$("alert-content")
    }, message)), div);
    return {
        close: close
    };
};
/* harmony default export */ const modal_alert = (alert_alert);

// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/ComUI/modal/index.less
var modal = __webpack_require__(41004);
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/dist/ComUI/modal/index.js




var _excluded = [
    "className",
    "style",
    "wrapClassName",
    "actionProps",
    "transparent",
    "maskTransitionName",
    "popup",
    "animationType",
    "animated",
    "transitionName",
    "zIndex",
    "title",
    "closable",
    "closeIcon",
    "footer",
    "iconFontProps"
];








var subPrefix = "Modal";
var cls$ = (0,cls/* default */.ZP)(subPrefix);
var defaultIconFontProps = {
    className: cls$("info-icon"),
    name: "InfoCircleFill",
    fontSize: 54,
    color: "var(--content-system-info-icon-regular, rgba(140, 192, 255, 100%))"
};
var Modal = function Modal(_ref) {
    var className = _ref.className, style = _ref.style, wrapClassName = _ref.wrapClassName, actionProps = _ref.actionProps, _ref$transparent = _ref.transparent, transparent = _ref$transparent === void 0 ? false : _ref$transparent, maskTransitionName = _ref.maskTransitionName, _ref$popup = _ref.popup, popup = _ref$popup === void 0 ? false : _ref$popup, _ref$animationType = _ref.animationType, animationType = _ref$animationType === void 0 ? "slide-down" : _ref$animationType, _ref$animated = _ref.animated, animated = _ref$animated === void 0 ? true : _ref$animated, transitionName = _ref.transitionName, _ref$zIndex = _ref.zIndex, zIndex = _ref$zIndex === void 0 ? 999 : _ref$zIndex, title = _ref.title, _ref$closable = _ref.closable, closable = _ref$closable === void 0 ? true : _ref$closable, closeIcon = _ref.closeIcon, footer = _ref.footer, userIconFontProps = _ref.iconFontProps, restProps = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);
    var _ref2 = actionProps !== null && actionProps !== void 0 ? actionProps : {}, _ref2$actions = _ref2.actions, actions = _ref2$actions === void 0 ? [] : _ref2$actions, _ref2$direction = _ref2.direction, actionsDirection = _ref2$direction === void 0 ? "row" : _ref2$direction;
    var iconFontProps = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, defaultIconFontProps), userIconFontProps), {}, {
        className: classnames_default()(defaultIconFontProps.className, userIconFontProps === null || userIconFontProps === void 0 ? void 0 : userIconFontProps.className)
    });
    var renderFooterButton = function renderFooterButton(action) {
        var _action$style;
        return /*#__PURE__*/ react.createElement("button", {
            className: cls$("button"),
            role: "button",
            type: "button",
            onClick: function onClick(e) {
                e.preventDefault();
                if (action.onPress) {
                    action.onPress();
                }
            },
            style: (_action$style = action.style) !== null && _action$style !== void 0 ? _action$style : {}
        }, action.text);
    };
    var footerDom = footer !== null && footer !== void 0 ? footer : actions.length ? /*#__PURE__*/ react.createElement("div", {
        className: cls$("button-direction-".concat(actionsDirection), {
            "only-button": actions.length === 1
        }),
        role: "group"
    }, actions.map(function(button) {
        return renderFooterButton(button);
    })) : null;
    var transName;
    var maskTransName;
    if (animated) {
        // tslint:disable-next-line:prefer-conditional-expression
        if (transparent) {
            transName = maskTransName = "am-fade";
        } else {
            transName = maskTransName = "am-slide-up";
        }
        if (popup) {
            transName = animationType === "slide-up" ? "am-slide-up" : "am-slide-down";
            maskTransName = "am-fade";
        }
    }
    (0,react.useEffect)(function() {
        (0,bodyScrollLock_esm/* disableBodyScroll */.Qp)(document.body, {
            reserveScrollBarGap: true
        });
        return function() {
            return (0,bodyScrollLock_esm/* enableBodyScroll */.tG)(document.body);
        };
    }, []);
    var defaultCloseIconNode = /*#__PURE__*/ react.createElement(IconFont/* default */.Z, {
        name: "CrossBlack",
        color: "var(--content-system-tertiary)",
        fontSize: 14
    });
    return /*#__PURE__*/ react.createElement(rc_dialog_es, (0,esm_extends/* default */.Z)({}, restProps, {
        prefixCls: cls$(),
        className: classnames_default()(className, cls$((0,defineProperty/* default */.Z)({
            transparent: transparent,
            popup: popup
        }, "popup-".concat(animationType), popup && animationType))),
        closable: closable,
        closeIcon: closeIcon === null || closeIcon === false ? null : defaultCloseIconNode,
        wrapClassName: classnames_default()(wrapClassName, (0,defineProperty/* default */.Z)({}, cls$("wrap-popup"), popup)),
        transitionName: transitionName || transName,
        maskTransitionName: maskTransitionName || maskTransName,
        style: (0,objectSpread2/* default */.Z)({
            // @ts-expect-error TS suppress
            "--zindex": zIndex
        }, style),
        title: /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(IconFont/* default */.Z, iconFontProps), /*#__PURE__*/ react.createElement("div", {
            className: cls$("real-title")
        }, title)),
        footer: footerDom,
        zIndex: zIndex
    }));
};
Modal.alert = modal_alert;
/* harmony default export */ const ComUI_modal = (Modal);


/***/ }),

/***/ 69868:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _meitu_xdesign_icon_font__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74107);
/* harmony import */ var _ComUI_commonModal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40451);
/* harmony import */ var _index_less__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(58322);
/* harmony import */ var _index_less__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_index_less__WEBPACK_IMPORTED_MODULE_1__);




/**
 * 身份切换后的确认弹窗
 */ var ConfirmModal = function ConfirmModal(props) {
    var description = props.description, onOk = props.onOk;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ComUI_commonModal__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        destroyOnClose: true,
        open: true,
        zIndex: 1000000001 // 这么大是因为业务引导弹窗库的层级是1000000000
        ,
        className: "xdesign-team-confirm-modal"
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        className: "xdesign-team-confirm-modal__body"
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        className: "xdesign-team-confirm-modal__tip"
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_meitu_xdesign_icon_font__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        fontSize: 54,
        name: "InfoCircleFill",
        color: "var(--content-system-info-icon-regular,#8cc0ff)"
    })), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        className: "xdesign-team-confirm-modal__title"
    }, "您的身份已被切换"), description ? /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        className: "xdesign-team-confirm-modal__description"
    }, description) : null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        className: "xdesign-team-confirm-modal__btn",
        onClick: onOk
    }, "确定")));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.memo(ConfirmModal));


/***/ }),

/***/ 56157:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "uL": () => (/* binding */ InviteModalAfterReload),
  "WM": () => (/* binding */ openInviteModal),
  "ce": () => (/* binding */ useOpenInviteModalFromQuery)
});

// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(19945);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(70072);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(38389);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@babel/runtime/helpers/esm/objectSpread2.js
var objectSpread2 = __webpack_require__(81549);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(69222);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-modal-open/dist/createModalComponent.js + 1 modules
var createModalComponent = __webpack_require__(69289);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/node_modules/@meitu/xdesign-icon-font/dist/IconFont.js + 2 modules
var IconFont = __webpack_require__(74107);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/ComUI/modal/index.js + 22 modules
var modal = __webpack_require__(48814);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/ComUI/commonModal/index.js
var commonModal = __webpack_require__(40451);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/ComUI/message/index.js
var message = __webpack_require__(20134);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/types/teamInfo.js
var teamInfo = __webpack_require__(32485);
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/dist/share/utils/index.js


/** 获取带文案的分享链接 */ var getSharedUrlWidthText = function getSharedUrlWidthText(_ref) {
    var shareUrl = _ref.shareUrl, name = _ref.name, type = _ref.type;
    var NAME_LENGTH = 8;
    var sliceName = name.length > NAME_LENGTH ? (name === null || name === void 0 ? void 0 : name.slice(0, NAME_LENGTH)) + "..." : name;
    var urlMap = (0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)({}, teamInfo/* TeamShareNodeType.RECORD */.iJ.RECORD, "".concat(shareUrl, "#我分享了【").concat(sliceName, "】，点击查看")), teamInfo/* TeamShareNodeType.TEMPLATE */.iJ.TEMPLATE, "".concat(shareUrl, "#我分享了【").concat(sliceName, "】，点击查看")), teamInfo/* TeamShareNodeType.FOLDER */.iJ.FOLDER, "".concat(shareUrl, "#我分享了【").concat(sliceName, "】，点击查看")), "invite", "".concat(shareUrl, "#我邀请你加入【").concat(sliceName, "】，点击加入")), "applyVisit", "".concat(shareUrl, "#我请求访问【").concat(sliceName, "】，点击处理申请")), "applyEdit", "".concat(shareUrl, "#我请求编辑【").concat(sliceName, "】，点击处理申请"));
    return urlMap[type];
};

// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/utils/url.js
var url = __webpack_require__(86984);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/teamInfo/index.js
var dist_teamInfo = __webpack_require__(46718);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/teamInfo/api/index.js + 1 modules
var api = __webpack_require__(37057);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/teamInfo/usePermissions.js
var usePermissions = __webpack_require__(90076);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/teamInfo/utils/index.js + 41 modules
var utils = __webpack_require__(56767);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/teamInfo/inviteModal/index.less
var inviteModal = __webpack_require__(21385);
;// CONCATENATED MODULE: ./node_modules/@meitu/xdesign-widgets/dist/teamInfo/inviteModal/index.js


















/** 有效期配置 */ var expiredConfig = [
    {
        label: "7天",
        value: 7
    },
    {
        label: "30天",
        value: 30
    },
    {
        label: "永久",
        alias: "永久有效",
        value: 0
    }
];
/** 权限配置 */ var roleConfig = [
    {
        label: "管理员",
        value: teamInfo/* TeamRoleType.admin */.xO.admin
    },
    {
        label: "成员",
        value: teamInfo/* TeamRoleType.member */.xO.member
    }
];
/**
 * 生成团队邀请链接弹窗
 * ?inviteKey=xxxxxxxx
 */ var InviteModalComp = function InviteModalComp(_ref) {
    var _roleConfig$find;
    var entrance = _ref.entrance, onClose = _ref.onClose, onOpenVipModal = _ref.onOpenVipModal, onTrack = _ref.onTrack;
    var _useState = (0,react.useState)(""), _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2), inviteUrl = _useState2[0], setInviteUrl = _useState2[1];
    var inviteId = (0,react.useRef)(0);
    var _useState3 = (0,react.useState)(false), _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2), isCopy = _useState4[0], setIsCopy = _useState4[1];
    // 目前改为30天有效期，且不支持选择
    var _useState5 = (0,react.useState)(expiredConfig[1].value), _useState6 = (0,slicedToArray/* default */.Z)(_useState5, 2), expired = _useState6[0], _ = _useState6[1];
    var _useState7 = (0,react.useState)(roleConfig[1].value), _useState8 = (0,slicedToArray/* default */.Z)(_useState7, 2), role = _useState8[0], setRole = _useState8[1];
    var _useState9 = (0,react.useState)(false), _useState10 = (0,slicedToArray/* default */.Z)(_useState9, 2), __ = _useState10[0], setOpenSelectExpired = _useState10[1];
    var _useState11 = (0,react.useState)(false), _useState12 = (0,slicedToArray/* default */.Z)(_useState11, 2), openSelectRole = _useState12[0], setOpenSelectRole = _useState12[1];
    var _useState13 = (0,react.useState)(null), _useState14 = (0,slicedToArray/* default */.Z)(_useState13, 2), remaingNum = _useState14[0], setRemaingNum = _useState14[1];
    var isGenerate = (0,react.useRef)(false);
    var teamInfo = (0,dist_teamInfo/* useTeamInfoState */.fM)();
    var hasFetchTeamInfo = (0,dist_teamInfo/* useHasFetchTeamInfoState */.Yr)();
    var isFreeTeam = (0,dist_teamInfo/* checkTeamStatusIsFree */.rM)(teamInfo);
    var popupClickTrack = function popupClickTrack(className) {
        onTrack === null || onTrack === void 0 || onTrack("popup_click", {
            popup_type: "invite",
            entrance: entrance,
            class: className
        });
    };
    // 关闭
    var closeHandle = function closeHandle() {
        onClose === null || onClose === void 0 || onClose();
        popupClickTrack("cancel");
    };
    var copyHandle = function copyHandle() {
        if (!inviteUrl) return;
        navigator.clipboard.writeText(inviteUrl);
        setIsCopy(true);
        popupClickTrack("copy_link");
    };
    (0,react.useEffect)(function() {
        onTrack === null || onTrack === void 0 || onTrack("popup_show", {
            popup_type: "invite",
            entrance: entrance
        });
    }, []);
    (0,react.useEffect)(function() {
        if (!hasFetchTeamInfo) return;
        if (isGenerate.current) return;
        isGenerate.current = true;
        var teamInfo = (0,dist_teamInfo/* getTeamInfo */.Iu)();
        (0,api/* generateInvite */.tc)({
            expired_days: expired,
            role: role,
            entrance: entrance,
            teamInfo: teamInfo
        }).then(function(res) {
            var _teamInfo$identity$li, _teamInfo$identity$li2;
            inviteId.current = res.id;
            var name = (_teamInfo$identity$li = teamInfo === null || teamInfo === void 0 || (_teamInfo$identity$li2 = teamInfo.identity.list.find(function(item) {
                return item.oid === teamInfo.identity.oid;
            })) === null || _teamInfo$identity$li2 === void 0 ? void 0 : _teamInfo$identity$li2.name) !== null && _teamInfo$identity$li !== void 0 ? _teamInfo$identity$li : "";
            var inviteUrl = getSharedUrlWidthText({
                shareUrl: res.shortUrl,
                name: name,
                type: "invite"
            });
            setInviteUrl(inviteUrl);
            setRemaingNum(res.seat.remaing);
        }).catch(function() {
            isGenerate.current = false;
        });
    }, [
        expired,
        role,
        hasFetchTeamInfo
    ]);
    function changeInviteHandle(args) {
        if (inviteId.current) {
            (0,api/* generateInvite */.tc)((0,objectSpread2/* default */.Z)({
                id: inviteId.current,
                entrance: entrance,
                teamInfo: (0,dist_teamInfo/* getTeamInfo */.Iu)()
            }, args));
        }
    }
    /** 打开团队首次购买会员/续费场景 */ var openVipTeamNormalModal = function openVipTeamNormalModal(args) {
        return onOpenVipModal === null || onOpenVipModal === void 0 ? void 0 : onOpenVipModal((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, args), {}, {
            purchase_scene: "normal",
            oid: teamInfo === null || teamInfo === void 0 ? void 0 : teamInfo.identity.oid,
            groupId: teamInfo === null || teamInfo === void 0 ? void 0 : teamInfo.identity.groupId
        }));
    };
    /** 打开团队加购席位 */ var openVipTeamExtraModal = function openVipTeamExtraModal(args) {
        return onOpenVipModal === null || onOpenVipModal === void 0 ? void 0 : onOpenVipModal((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, args), {}, {
            purchase_scene: "extra",
            subscribe_type: "subscription",
            oid: teamInfo === null || teamInfo === void 0 ? void 0 : teamInfo.identity.oid,
            groupId: teamInfo === null || teamInfo === void 0 ? void 0 : teamInfo.identity.groupId
        }));
    };
    // 接口数据还没返回时, 不显示, 防止组件样式严重闪烁
    if (remaingNum === null) return /*#__PURE__*/ react.createElement(react.Fragment, null);
    if (remaingNum === 0) {
        var _teamInfo$member$team, _teamInfo$member;
        return /*#__PURE__*/ react.createElement(modal/* default */.Z, {
            visible: true,
            title: isFreeTeam ? "免费版最多支持".concat((_teamInfo$member$team = teamInfo === null || teamInfo === void 0 || (_teamInfo$member = teamInfo.member) === null || _teamInfo$member === void 0 ? void 0 : _teamInfo$member.team.member_detail.valid_num) !== null && _teamInfo$member$team !== void 0 ? _teamInfo$member$team : 0, "名成员") : "会员席位不足",
            onClose: onClose,
            actionProps: {
                actions: [
                    {
                        style: {
                            background: "var(--background-btn-svip)",
                            // css变量有问题，暂时用硬编码
                            color: "#653619",
                            fontWeight: 500
                        },
                        text: /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(IconFont/* default */.Z, {
                            name: "VipBoldFill",
                            fontSize: 12,
                            style: {
                                marginRight: 4
                            }
                        }), isFreeTeam ? "升级团队版" : "加购席位"),
                        onPress: function onPress() {
                            (isFreeTeam ? openVipTeamNormalModal : openVipTeamExtraModal)({
                                entrance: "popup",
                                second_source: "upper_limit"
                            });
                            onClose === null || onClose === void 0 || onClose();
                            popupClickTrack("add_seat");
                        }
                    }
                ]
            }
        }, /*#__PURE__*/ react.createElement("div", {
            style: {
                marginTop: 8,
                color: "var(--content-system-tertiary, #939599)",
                textAlign: "center",
                fontFamily: "PingFang SC",
                fontSize: 14,
                fontStyle: "normal",
                fontWeight: 400,
                lineHeight: "20px"
            }
        }, isFreeTeam ? "若需提高席位上限可升级团队版" : "若需继续邀请成员请先加购席位"));
    }
    return /*#__PURE__*/ react.createElement(commonModal/* default */.Z, {
        destroyOnClose: true,
        open: true,
        zIndex: 1000000001 // 这么大是因为业务引导弹窗库的层级是1000000000
        ,
        className: "Widget-teamSpaceInviteModal"
    }, /*#__PURE__*/ react.createElement("div", {
        className: "Widget teamSpaceInviteModal",
        onClick: function onClick() {
            setOpenSelectExpired(false);
            setOpenSelectRole(false);
        }
    }, /*#__PURE__*/ react.createElement("div", {
        className: "close",
        onClick: closeHandle
    }, /*#__PURE__*/ react.createElement(IconFont/* default */.Z, {
        fontSize: 14,
        name: "CrossBlack",
        color: "var(--content-system-tertiary)"
    })), /*#__PURE__*/ react.createElement("div", {
        className: "header"
    }, "邀请成员"), /*#__PURE__*/ react.createElement("div", {
        className: "seat"
    }, "您还可以", (0,dist_teamInfo/* checkTeamStatusIsFree */.rM)(teamInfo) ? "免费" : "", "邀请 ", /*#__PURE__*/ react.createElement("span", null, remaingNum, "个"), " 成员加入团队"), /*#__PURE__*/ react.createElement("div", {
        className: "rights"
    }, /*#__PURE__*/ react.createElement("div", {
        className: "right-item"
    }, /*#__PURE__*/ react.createElement(IconFont/* default */.Z, {
        name: "ShareBold",
        fontSize: 16,
        color: "var(--content-system-secondary, #616366)"
    }), "一起分享设计成果和素材"), /*#__PURE__*/ react.createElement("div", {
        className: "right-item"
    }, /*#__PURE__*/ react.createElement(IconFont/* default */.Z, {
        name: "VipBold",
        fontSize: 16,
        color: "var(--content-system-secondary, #616366)"
    }), "一起共享会员和AI生成额度（美豆）")), /*#__PURE__*/ react.createElement("div", {
        className: "divider"
    }), /*#__PURE__*/ react.createElement("div", {
        className: "member-rights"
    }, "受邀用户的权限：", /*#__PURE__*/ react.createElement("div", {
        className: classnames_default()("role", {
            active: openSelectRole
        }),
        onClick: function onClick(e) {
            e.stopPropagation();
            setOpenSelectExpired(false);
            setOpenSelectRole(!openSelectRole);
        }
    }, (_roleConfig$find = roleConfig.find(function(v) {
        return v.value === role;
    })) === null || _roleConfig$find === void 0 ? void 0 : _roleConfig$find.label, /*#__PURE__*/ react.createElement(IconFont/* default */.Z, {
        fontSize: 10,
        name: "ChevronDownBlack",
        color: "var(--content-input-lable)"
    }), openSelectRole ? /*#__PURE__*/ react.createElement("div", {
        className: "select select-role"
    }, roleConfig.map(function(item, index) {
        return /*#__PURE__*/ react.createElement("div", {
            key: index,
            className: classnames_default()("item", {
                active: item.value === role
            }),
            onClick: function onClick(e) {
                e.stopPropagation();
                setRole(item.value);
                setOpenSelectRole(false);
                changeInviteHandle({
                    role: item.value
                });
                popupClickTrack("identity");
            }
        }, item.label);
    })) : null)), /*#__PURE__*/ react.createElement("div", {
        className: "body"
    }, /*#__PURE__*/ react.createElement("div", {
        className: "urlBox"
    }, /*#__PURE__*/ react.createElement("div", {
        className: "url",
        onClick: function onClick() {
            return copyHandle();
        }
    }, inviteUrl)), /*#__PURE__*/ react.createElement("div", {
        className: "btns"
    }, /*#__PURE__*/ react.createElement("div", {
        className: "copy",
        onClick: function onClick() {
            return copyHandle();
        }
    }, isCopy ? /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(IconFont/* default */.Z, {
        fontSize: 16,
        name: "CheckCircleFillBold",
        color: "#ffffff"
    }), /*#__PURE__*/ react.createElement("span", null, "已复制")) : "复制链接")))));
};
InviteModalComp.displayName = "InviteModalComp";
var InviteModalWithPermission = function InviteModalWithPermission(props) {
    var _usePermissions = (0,usePermissions/* default */.Z)(), permissions = _usePermissions.permissions, loading = _usePermissions.loading;
    var hasInvitePermission = !(0,utils/* isSSO */.yf)() && permissions["member.invite"];
    (0,react.useEffect)(function() {
        if (loading) return;
        if (!hasInvitePermission) {
            message/* default.error */.Z.error("只有团队所有者/管理员可以邀请，您暂时没有权限邀请他人加入团队");
        }
    }, [
        loading,
        hasInvitePermission
    ]);
    if (loading) return null;
    if (!loading && !hasInvitePermission) return null;
    return /*#__PURE__*/ react.createElement(InviteModalComp, props);
};
InviteModalWithPermission.displayName = "InviteModalWithPermission";
var _createModalComponent = (0,createModalComponent/* default */.Z)(InviteModalWithPermission), openInviteModal = _createModalComponent.open;
/** 控制身份切换导致页面刷新后，自动打开邀请弹窗 */ 
var InviteModalAfterReload = /*#__PURE__*/ function() {
    function InviteModalAfterReload() {
        (0,classCallCheck/* default */.Z)(this, InviteModalAfterReload);
    }
    (0,createClass/* default */.Z)(InviteModalAfterReload, null, [
        {
            key: "init",
            value: /** 初始化, 用于在页面加载时, 自动打开邀请弹窗 */ function init(params) {
                if (this.isInit) return;
                this.isInit = true;
                var recordParams = window.localStorage.getItem(this.LOCAL_STORAGE_KEY);
                window.localStorage.removeItem(this.LOCAL_STORAGE_KEY);
                if (recordParams !== null) {
                    var recordParamsObj = JSON.parse(recordParams);
                    openInviteModal((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, recordParamsObj), params));
                }
            }
        },
        {
            key: "prepareOpen",
            value: function prepareOpen(params) {
                if ((0,utils/* isSSO */.yf)() || (0,dist_teamInfo/* isFromZhanKu */.b6)()) return;
                window.localStorage.setItem(this.LOCAL_STORAGE_KEY, JSON.stringify(params));
            }
        }
    ]);
    return InviteModalAfterReload;
}();
(0,defineProperty/* default */.Z)(InviteModalAfterReload, "isInit", false);
(0,defineProperty/* default */.Z)(InviteModalAfterReload, "LOCAL_STORAGE_KEY", "invite_modal_after_reload");
var useOpenInviteModalFromQuery = function useOpenInviteModalFromQuery() {
    var QUERY_KEY = "openInviteModal";
    var QUERY_KEY_ENTRANCE = "openInviteModalEntrance";
    var init = function init(params) {
        if ((0,url/* getQueryParam */.Ph)(QUERY_KEY) === "1") {
            var entrance = (0,url/* getQueryParam */.Ph)(QUERY_KEY_ENTRANCE);
            (0,url/* deleteQueryParams */.Ow)(QUERY_KEY);
            (0,url/* deleteQueryParams */.Ow)(QUERY_KEY_ENTRANCE);
            openInviteModal({
                entrance: entrance,
                onTrack: params.onTrack,
                onOpenVipModal: params.onOpenVipModal
            });
        }
    };
    var reloadAndOpenInviteModal = function reloadAndOpenInviteModal() {
        var entrance = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "auto_pop";
        if ((0,utils/* isSSO */.yf)() || (0,dist_teamInfo/* isFromZhanKu */.b6)()) return;
        // TODO: 未来changeIdentity url改造
        (0,url/* appendQueryParams */.DZ)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)({}, QUERY_KEY, 1), QUERY_KEY_ENTRANCE, entrance));
        window.location.reload();
    };
    return {
        init: init,
        reloadAndOpenInviteModal: reloadAndOpenInviteModal
    };
};


/***/ }),

/***/ 30938:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(81549);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(56369);
/* harmony import */ var _babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(89255);
/* harmony import */ var _babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(87406);
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(33641);
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69222);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _meitu_xdesign_identity__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10275);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(46718);
/* harmony import */ var _configProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97303);
/* harmony import */ var _utils_eventBus__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(77724);
/* harmony import */ var _confirmModal__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(69868);
/* harmony import */ var _expiredModal__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(40769);
/* harmony import */ var _freezeModal__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(72715);
/* harmony import */ var _inviteModal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56157);
/* harmony import */ var _loginIdentitySwitchModal__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(65229);
















var instance = null;
/** 团队弹窗 */ var TeamInfoModal = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.memo(function(_ref) {
    var _switchModalOpenArgs$;
    var disabledMask = _ref.disabledMask, maskPassThroughSelector = _ref.maskPassThroughSelector, _ref$isTeamHome = _ref.isTeamHome, isTeamHome = _ref$isTeamHome === void 0 ? false : _ref$isTeamHome, confirmPopupDesc = _ref.confirmPopupDesc, maskStyle = _ref.maskStyle, create_team_success_entrance = _ref.create_team_success_entrance, onDiff = _ref.onDiff, onChange = _ref.onChange, onOpenVipModal = _ref.onOpenVipModal, onCheckTeamOtherStatus = _ref.onCheckTeamOtherStatus, onTrack = _ref.onTrack;
    var _useOpenInviteModalFr = (0,_inviteModal__WEBPACK_IMPORTED_MODULE_2__/* .useOpenInviteModalFromQuery */ .ce)(), initOpenInviteModalFromQuery = _useOpenInviteModalFr.init;
    var _useConfig = (0,_configProvider__WEBPACK_IMPORTED_MODULE_3__/* .useConfig */ .ZR)(), isTeam = _useConfig.isTeam;
    var teamInfo = (0,___WEBPACK_IMPORTED_MODULE_4__/* .useTeamInfoState */ .fM)();
    var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
        open: false,
        type: null
    }), _useState2 = (0,_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_useState, 2), mask = _useState2[0], setMask = _useState2[1];
    var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), _useState4 = (0,_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_useState3, 2), switchModalStatus = _useState4[0], setSwitchModalStatus = _useState4[1];
    var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), _useState6 = (0,_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_useState5, 2), confirmStatus = _useState6[0], setConfirmStatus = _useState6[1];
    var _useState7 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0), _useState8 = (0,_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_useState7, 2), newOid = _useState8[0], setNewOid = _useState8[1];
    var _useState9 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0), _useState10 = (0,_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_useState9, 2), newGroupId = _useState10[0], setNewGroupId = _useState10[1];
    var changeStatusRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
    var isFirstRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(true);
    var _useState11 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]), _useState12 = (0,_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_useState11, 2), maskBlocks = _useState12[0], setMaskBlocks = _useState12[1];
    var _useState13 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({}), _useState14 = (0,_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_useState13, 2), switchModalOpenArgs = _useState14[0], setSwitchModalOpenArgs = _useState14[1];
    var _useConfig2 = (0,_configProvider__WEBPACK_IMPORTED_MODULE_3__/* .useConfig */ .ZR)(), userInfo = _useConfig2.userInfo;
    var openExpired = function openExpired() {
        (0,___WEBPACK_IMPORTED_MODULE_4__/* .openTeamExpiredPopup */ .kA)({
            entrance: "popup_window",
            onOK: function onOK(entrance) {
                onOpenVipModal === null || onOpenVipModal === void 0 || onOpenVipModal({
                    entrance: entrance,
                    oid: (teamInfo === null || teamInfo === void 0 ? void 0 : teamInfo.identity.oid) || 0,
                    groupId: (teamInfo === null || teamInfo === void 0 ? void 0 : teamInfo.identity.groupId) || 0,
                    purchase_scene: "normal",
                    subscribe_type: "subscription"
                });
            },
            onTrack: onTrack
        });
    };
    var openFreeze = function openFreeze() {
        (0,___WEBPACK_IMPORTED_MODULE_4__/* .openTeamFreezePopup */ .Gl)({
            entrance: "popup_window",
            onTrack: onTrack
        });
    };
    var triggerMaskPopup = function triggerMaskPopup() {
        switch(mask.type){
            case "expired":
                openExpired();
                break;
            case "freeze":
                openFreeze();
                break;
        }
    };
    var getPassThroughElements = function getPassThroughElements() {
        if (!maskPassThroughSelector) return [];
        var selectorList = Array.isArray(maskPassThroughSelector) ? maskPassThroughSelector : [
            maskPassThroughSelector
        ];
        var elements = [];
        selectorList.forEach(function(selector) {
            if (!selector) return;
            try {
                var element = document.querySelector(selector);
                if (element) {
                    elements.push(element);
                }
            } catch (_unused) {
            // 忽略非法选择器，继续处理其他选择器
            }
        });
        return elements;
    };
    var getMaskBlocksByPassThroughElements = function getMaskBlocksByPassThroughElements(passThroughElements) {
        var viewportWidth = window.innerWidth;
        var viewportHeight = window.innerHeight;
        if (!passThroughElements.length) {
            return [
                {
                    top: 0,
                    left: 0,
                    width: viewportWidth,
                    height: viewportHeight
                }
            ];
        }
        var passThroughRects = passThroughElements.map(function(element) {
            return element.getBoundingClientRect();
        }).map(function(rect) {
            return {
                left: Math.max(0, Math.min(viewportWidth, rect.left)),
                right: Math.max(0, Math.min(viewportWidth, rect.right)),
                top: Math.max(0, Math.min(viewportHeight, rect.top)),
                bottom: Math.max(0, Math.min(viewportHeight, rect.bottom))
            };
        }).filter(function(rect) {
            return rect.right > rect.left && rect.bottom > rect.top;
        });
        if (!passThroughRects.length) {
            return [
                {
                    top: 0,
                    left: 0,
                    width: viewportWidth,
                    height: viewportHeight
                }
            ];
        }
        var xBoundaries = Array.from(new Set([
            0,
            viewportWidth
        ].concat((0,_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(passThroughRects.flatMap(function(rect) {
            return [
                rect.left,
                rect.right
            ];
        }))))).sort(function(a, b) {
            return a - b;
        });
        var yBoundaries = Array.from(new Set([
            0,
            viewportHeight
        ].concat((0,_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(passThroughRects.flatMap(function(rect) {
            return [
                rect.top,
                rect.bottom
            ];
        }))))).sort(function(a, b) {
            return a - b;
        });
        var blocks = [];
        for(var xIndex = 0; xIndex < xBoundaries.length - 1; xIndex++){
            var left = xBoundaries[xIndex];
            var right = xBoundaries[xIndex + 1];
            if (right <= left) continue;
            var _loop = function _loop() {
                var top = yBoundaries[yIndex];
                var bottom = yBoundaries[yIndex + 1];
                if (bottom <= top) return 0; // continue
                var centerX = (left + right) / 2;
                var centerY = (top + bottom) / 2;
                var inPassThroughRect = passThroughRects.some(function(rect) {
                    return centerX >= rect.left && centerX <= rect.right && centerY >= rect.top && centerY <= rect.bottom;
                });
                if (inPassThroughRect) return 0; // continue
                blocks.push({
                    top: top,
                    left: left,
                    width: right - left,
                    height: bottom - top
                });
            }, _ret;
            for(var yIndex = 0; yIndex < yBoundaries.length - 1; yIndex++){
                _ret = _loop();
                if (_ret === 0) continue;
            }
        }
        return blocks;
    };
    var isMaskBlocksEqual = function isMaskBlocksEqual(prev, next) {
        if (prev.length !== next.length) return false;
        return prev.every(function(block, index) {
            var nextBlock = next[index];
            return block.top === nextBlock.top && block.left === nextBlock.left && block.width === nextBlock.width && block.height === nextBlock.height;
        });
    };
    var clearPopup = function clearPopup() {
        (0,___WEBPACK_IMPORTED_MODULE_4__/* .closeTeamFreezePopup */ .I3)();
        (0,___WEBPACK_IMPORTED_MODULE_4__/* .closeTeamExpiredPopup */ .Qn)();
        setMask({
            open: false,
            type: null
        });
    };
    // 触发业务身份切换逻辑
    var handleChange = /*#__PURE__*/ function() {
        var _ref2 = (0,_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(/*#__PURE__*/ (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)().mark(function _callee(oid, groupId) {
            return (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)().wrap(function _callee$(_context) {
                while(1)switch(_context.prev = _context.next){
                    case 0:
                        onChange === null || onChange === void 0 || onChange(oid, groupId);
                    case 1:
                    case "end":
                        return _context.stop();
                }
            }, _callee);
        }));
        return function handleChange(_x, _x2) {
            return _ref2.apply(this, arguments);
        };
    }();
    /**
   * 用户信息接口和团队信息接口并发请求
   * 如果用户信息接口先返回，则有uid，会重新再次触发团队信息接口，这时需要等第一次团队信息接口响应返回后再决定，如果有值则取消请求
   * @param userId
   */ var handleFetchTeamInfo = /*#__PURE__*/ function() {
        var _ref3 = (0,_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(/*#__PURE__*/ (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)().mark(function _callee2(userId) {
            var teamInfoData;
            return (0,_babel_runtime_helpers_esm_regeneratorRuntime__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)().wrap(function _callee2$(_context2) {
                while(1)switch(_context2.prev = _context2.next){
                    case 0:
                        teamInfoData = (0,___WEBPACK_IMPORTED_MODULE_4__/* .getTeamInfo */ .Iu)();
                        if (!teamInfoData) {
                            _context2.next = 3;
                            break;
                        }
                        return _context2.abrupt("return");
                    case 3:
                        _context2.prev = 3;
                        if (!instance) {
                            _context2.next = 9;
                            break;
                        }
                        _context2.next = 7;
                        return instance;
                    case 7:
                        _context2.next = 11;
                        break;
                    case 9:
                        _context2.next = 11;
                        return instance = (0,___WEBPACK_IMPORTED_MODULE_4__/* .fetchTeamInfo */ .mR)();
                    case 11:
                        if (userId && !teamInfoData) {
                            (0,___WEBPACK_IMPORTED_MODULE_4__/* .fetchTeamInfo */ .mR)();
                        }
                    case 12:
                        _context2.prev = 12;
                        instance = null;
                        return _context2.finish(12);
                    case 15:
                    case "end":
                        return _context2.stop();
                }
            }, _callee2, null, [
                [
                    3,
                    ,
                    12,
                    15
                ]
            ]);
        }));
        return function handleFetchTeamInfo(_x3) {
            return _ref3.apply(this, arguments);
        };
    }();
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        initOpenInviteModalFromQuery({
            onOpenVipModal: onOpenVipModal,
            onTrack: onTrack
        });
        _inviteModal__WEBPACK_IMPORTED_MODULE_2__/* .InviteModalAfterReload.init */ .uL.init({
            onOpenVipModal: onOpenVipModal,
            onTrack: onTrack
        });
    }, []);
    // 弹窗阻断
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        clearPopup();
        if (!(teamInfo !== null && teamInfo !== void 0 && teamInfo.member)) return;
        // 团队过期提示
        if ((0,___WEBPACK_IMPORTED_MODULE_4__/* .checkTeamIsEnterprise */ .Yt)(teamInfo) && !(0,___WEBPACK_IMPORTED_MODULE_4__/* .checkTeamStatusIsVip */ .zb)(teamInfo)) {
            openExpired();
            (0,___WEBPACK_IMPORTED_MODULE_4__/* .closeTeamFreezePopup */ .I3)();
            setMask({
                open: true,
                type: "expired"
            });
            return;
        }
        // 席位冻结 or 当前用户没有席位
        if ((0,___WEBPACK_IMPORTED_MODULE_4__/* .checkUserSeatIsFreeze */ .vn)(teamInfo) || !(0,___WEBPACK_IMPORTED_MODULE_4__/* .checkUserHasSeat */ .gS)(teamInfo)) {
            openFreeze();
            (0,___WEBPACK_IMPORTED_MODULE_4__/* .closeTeamExpiredPopup */ .Qn)();
            setMask({
                open: true,
                type: "freeze"
            });
            return;
        }
        onCheckTeamOtherStatus === null || onCheckTeamOtherStatus === void 0 || onCheckTeamOtherStatus();
    }, [
        teamInfo
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        // 页面第一次加载, uid=0，需要默认加载团队接口
        // 非页面第一次加载且退出登录操作时uid=0，此时已经调用 clearTeamInfo清空团队信息，不需要重新调用接口
        if (!isTeam || !userInfo.id && !isFirstRef.current) return;
        handleFetchTeamInfo(userInfo.id);
        isFirstRef.current = false;
    }, [
        userInfo.id
    ]);
    // 弹出身份选择
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var changeHandle = function changeHandle() {
            onDiff === null || onDiff === void 0 || onDiff();
        };
        _utils_eventBus__WEBPACK_IMPORTED_MODULE_9__/* ["default"].addListener */ .Z.addListener(___WEBPACK_IMPORTED_MODULE_4__/* .CHANGE_TEAM_OID */ .Uy, changeHandle);
        return function() {
            _utils_eventBus__WEBPACK_IMPORTED_MODULE_9__/* ["default"].removeListener */ .Z.removeListener(___WEBPACK_IMPORTED_MODULE_4__/* .CHANGE_TEAM_OID */ .Uy, changeHandle);
        };
    }, [
        onDiff
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        (0,_meitu_xdesign_identity__WEBPACK_IMPORTED_MODULE_1__/* .addStorageChangeListener */ .lQ)(function(oid, groupId) {
            // 已经提示中了或者未登录态下，不需要触发业务的onChange回调
            if (changeStatusRef.current || !(0,___WEBPACK_IMPORTED_MODULE_4__/* .getIdentityChangeListenerStatus */ .gm)() || !isTeam) return;
            changeStatusRef.current = true;
            if (!(0,___WEBPACK_IMPORTED_MODULE_4__/* .getIsSwitchIdentityInitiative */ .$v)()) {
                // 非激活态tab页面属于被动提示身份切换
                setNewOid(oid);
                setNewGroupId(groupId);
                setConfirmStatus(true);
            } else {
                // 激活态页面，主动切换身份，不需要提示弹窗
                handleChange(oid, groupId);
            }
        });
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (!isTeam) {
            (0,_meitu_xdesign_identity__WEBPACK_IMPORTED_MODULE_1__/* .disableTeamIdentity */ .Yb)();
        } else {
            (0,_meitu_xdesign_identity__WEBPACK_IMPORTED_MODULE_1__/* .enableTeamIdentity */ .lD)();
        }
    }, [
        isTeam
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var shouldShowMask = !isTeamHome && !disabledMask && mask.open;
        if (!shouldShowMask) {
            setMaskBlocks([]);
            return;
        }
        var frameId = 0;
        var resizeObserver = null;
        var mutationObserver = null;
        var updateMaskBlocks = function updateMaskBlocks() {
            var passThroughElements = getPassThroughElements();
            // 目标元素可能是异步渲染的，每次更新时都同步更新观察目标
            if (resizeObserver) {
                resizeObserver.disconnect();
                passThroughElements.forEach(function(element) {
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) === null || _resizeObserver === void 0 || _resizeObserver.observe(element);
                });
            }
            var nextMaskBlocks = getMaskBlocksByPassThroughElements(passThroughElements);
            setMaskBlocks(function(prevMaskBlocks) {
                return isMaskBlocksEqual(prevMaskBlocks, nextMaskBlocks) ? prevMaskBlocks : nextMaskBlocks;
            });
        };
        var scheduleUpdate = function scheduleUpdate() {
            if (frameId) return;
            frameId = window.requestAnimationFrame(function() {
                frameId = 0;
                updateMaskBlocks();
            });
        };
        scheduleUpdate();
        window.addEventListener("resize", scheduleUpdate);
        window.addEventListener("scroll", scheduleUpdate, true);
        if (typeof ResizeObserver !== "undefined") {
            resizeObserver = new ResizeObserver(scheduleUpdate);
        }
        if (typeof MutationObserver !== "undefined") {
            mutationObserver = new MutationObserver(scheduleUpdate);
            mutationObserver.observe(document.documentElement, {
                childList: true,
                subtree: true,
                attributes: true,
                attributeFilter: [
                    "class",
                    "style"
                ]
            });
        }
        return function() {
            var _resizeObserver2, _mutationObserver;
            if (frameId) {
                window.cancelAnimationFrame(frameId);
            }
            window.removeEventListener("resize", scheduleUpdate);
            window.removeEventListener("scroll", scheduleUpdate, true);
            (_resizeObserver2 = resizeObserver) === null || _resizeObserver2 === void 0 || _resizeObserver2.disconnect();
            (_mutationObserver = mutationObserver) === null || _mutationObserver === void 0 || _mutationObserver.disconnect();
        };
    }, [
        isTeamHome,
        disabledMask,
        mask.open,
        maskPassThroughSelector
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var onOpen = function onOpen(data) {
            if (!isTeam) return;
            setSwitchModalStatus(true);
            setSwitchModalOpenArgs(data);
        };
        var onClose = function onClose() {
            if (!isTeam) return;
            setSwitchModalStatus(false);
            setSwitchModalOpenArgs({});
        };
        _utils_eventBus__WEBPACK_IMPORTED_MODULE_9__/* ["default"].addListener */ .Z.addListener(_loginIdentitySwitchModal__WEBPACK_IMPORTED_MODULE_10__/* .SHOW_IDENTITY_SWITCH_MODAL */ .Mg, onOpen);
        _utils_eventBus__WEBPACK_IMPORTED_MODULE_9__/* ["default"].addListener */ .Z.addListener(_loginIdentitySwitchModal__WEBPACK_IMPORTED_MODULE_10__/* .HIDDEN_IDENTITY_SWITCH_MODAL */ .BM, onClose);
        return function() {
            _utils_eventBus__WEBPACK_IMPORTED_MODULE_9__/* ["default"].removeListener */ .Z.removeListener(_loginIdentitySwitchModal__WEBPACK_IMPORTED_MODULE_10__/* .SHOW_IDENTITY_SWITCH_MODAL */ .Mg, onOpen);
            _utils_eventBus__WEBPACK_IMPORTED_MODULE_9__/* ["default"].removeListener */ .Z.removeListener(_loginIdentitySwitchModal__WEBPACK_IMPORTED_MODULE_10__/* .HIDDEN_IDENTITY_SWITCH_MODAL */ .BM, onClose);
        };
    }, []);
    if (!isTeam) return null;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, !isTeamHome && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_expiredModal__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP, {
        identityList: teamInfo === null || teamInfo === void 0 ? void 0 : teamInfo.identity.list
    }), !isTeamHome && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_freezeModal__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP, null), confirmStatus && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_confirmModal__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
        description: confirmPopupDesc,
        onOk: function onOk() {
            setConfirmStatus(false);
            handleChange(newOid, newGroupId);
        }
    }), switchModalStatus && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_loginIdentitySwitchModal__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({}, switchModalOpenArgs, {
        create_team_success_entrance: (_switchModalOpenArgs$ = switchModalOpenArgs.create_team_success_entrance) !== null && _switchModalOpenArgs$ !== void 0 ? _switchModalOpenArgs$ : create_team_success_entrance,
        onClose: function onClose() {
            setSwitchModalStatus(false);
            setSwitchModalOpenArgs({});
        },
        onTrack: onTrack
    })), !isTeamHome && !disabledMask && mask.open && maskBlocks.map(function(block, index) {
        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
            key: "team-info-mask-block-".concat(index),
            style: (0,_babel_runtime_helpers_esm_objectSpread2__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({
                position: "fixed",
                zIndex: 999,
                top: block.top,
                left: block.left,
                width: block.width,
                height: block.height
            }, maskStyle || {}),
            onClick: triggerMaskPopup
        });
    }));
});
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (TeamInfoModal);


/***/ }),

/***/ 90076:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69222);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46718);
/* harmony import */ var _api__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(37057);




var cachedOperatePermission = null;
var promise = null;
var usePermissions = function usePermissions() {
    var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
        "team.info": false,
        "team.update": false,
        "team.contact": false,
        "team.pay": false,
        "team.unregister": false,
        "data.summary": false,
        "member.list": false,
        "member.invite": false,
        "member.change_role": false,
        "member.remove": false,
        "order.list": false,
        "order.make_invoice": false,
        "accredit.list": false,
        "accredit.create": false
    }), _useState2 = (0,_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_useState, 2), permissions = _useState2[0], setPermissions = _useState2[1];
    var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(true), _useState4 = (0,_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_useState3, 2), loading = _useState4[0], setLoading = _useState4[1];
    var hasFetchTeamInfo = (0,___WEBPACK_IMPORTED_MODULE_2__/* .useHasFetchTeamInfoState */ .Yr)();
    var isTeam = (0,___WEBPACK_IMPORTED_MODULE_2__/* .checkIsTeam */ .hU)((0,___WEBPACK_IMPORTED_MODULE_2__/* .useTeamInfoState */ .fM)());
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (!hasFetchTeamInfo) return;
        if (!isTeam) {
            setLoading(false);
            return;
        }
        if (cachedOperatePermission) {
            setPermissions(cachedOperatePermission);
            setLoading(false);
            return;
        }
        if (!promise) promise = (0,_api__WEBPACK_IMPORTED_MODULE_3__/* .fetchMemberPermission */ .bE)();
        promise.then(function(keys) {
            var res = keys.reduce(function(acc, key) {
                acc[key] = true;
                return acc;
            }, {});
            setPermissions(res);
            cachedOperatePermission = res;
            promise = null;
            setLoading(false);
        }).catch(function() {
            setLoading(false);
        });
    }, [
        hasFetchTeamInfo,
        isTeam
    ]);
    return {
        permissions: permissions,
        loading: loading
    };
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (usePermissions);


/***/ }),

/***/ 41004:
/***/ (() => {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 58322:
/***/ (() => {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 21385:
/***/ (() => {

// extracted by mini-css-extract-plugin

/***/ })

}]);